import type { ZodiosPlugin } from "@zodios/core";

import type { FuseErrorResponse } from "@shared/fuse-api";

import { captureException } from "@sentry/react";
import { isAxiosError } from "axios";
import { navigate } from "wouter/use-browser-location";

const getFuseApiError = (error: unknown): FuseErrorResponse | undefined => {
	if (isAxiosError<FuseErrorResponse>(error)) {
		return error.response?.data;
	}

	return undefined;
};

export function pluginError(): ZodiosPlugin {
	return {
		error: async (_api, _config, error) => {
			// Enrich error with message from Fuse API
			error.message = getFuseApiError(error)?.message || error.message;

			if (isAxiosError<FuseErrorResponse>(error)) {
				// Handle session authentication error
				if (
					error.message.toLocaleLowerCase().includes("unauthorized") ||
					error.response?.status === 401
				) {
					navigate("/logged-out");
					return Promise.reject(error);
				}
			} else {
				captureException(error);
			}

			throw error;
		},
	};
}
